var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex justify-content-center align-items-center",class:{ 'interview-window': _vm.interviewHeight }},[_c('loading',{attrs:{"color":"primary","size":65}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }